export default function getFormProperties(form) {
  const properties = {};
  if (!form) return properties;

  const inputs = form.querySelectorAll('[name^="properties"]');
  if (!inputs) return properties;

  [...inputs].forEach((el) => {
    const name = el.name.match(/\[(.*)\]/)[1];
    properties[name] = el.value;
  });

  return properties;
}
